import { render } from "./ViewOuvFerm.vue?vue&type=template&id=19dfe6f2&scoped=true&ts=true"
import script from "./ViewOuvFerm.vue?vue&type=script&lang=ts"
export * from "./ViewOuvFerm.vue?vue&type=script&lang=ts"

import "./ViewOuvFerm.vue?vue&type=style&index=0&id=19dfe6f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dfe6f2"]])

export default __exports__